import React from 'react';
import { Label } from '../Label';
import { SvgIncludedCharger } from '@rakutenfrance/shared-svg';
export const IncludedChargerLabel = () => {
    return (React.createElement(Label, { textColor: "gray800", letterSpacing: "normal", backgroundColor: "gray100", padding: "medium", textTransform: "none", gap: "4px" },
        React.createElement(SvgIncludedCharger, null),
        "Adaptateur secteur inclus"));
};
